import React, { useCallback, useEffect, useState } from 'react';
import { Box } from '@material-ui/core';
import ExpressionsOfInterest from '../../../../commonSteps/extras/components/expressionsOfInterest/ExpressionsOfInterest';
import useCheckoutContext from '../../../../common/hooks/useCheckoutContext';
import Loader from '../../../../../common/components/presentation/Loader/Loader';
import extrasStyles from './extrasStyles';
import { Routes } from '../../../../../common/enum/Routes';
import { useHistory } from 'react-router';
import collectedFilters from '../../../../../common/service/collectedFilters';
import { useSaveExpressionsOfInterest } from '../../../../commonSteps/extras/hooks/mutations/useSaveExpressionsOfInterest';
import useJourneyStepsContext from '../../../hooks/useJourneyStepsContext';
import ContinueButton from '../../buttons/continueButton/ContinueButton';
import useNewDxpDigitalAssignmentEntryEvent from '../../../../../gql/common/hooks/useNewDxpDigitalAssignmentEntryEvents';
import { EventDataTypes } from '../../../../../gql/common/enum/DataLayerEnums';
import usePlatformConfig from '../../../../../common/react/usePlatformConfig';
import { DxpDataLayerEventNames } from '../../../../../../../common/utilities/customDatalayerInterface';
import {
  getCheckoutStepsCommonFields,
  getEventDataCommonFields,
  getPurchaseOptionCommonFields,
  vproductCommonFields,
  removeHostNameFromUrl,
} from '../../../../../gql/common/utils/dxpDataLayerCommonFields';

const Extras = () => {
  const styles = extrasStyles();
  const history = useHistory();
  const { handleNext, steps, activeStep } = useJourneyStepsContext();
  const { saveExpressionsOfInterest } = useSaveExpressionsOfInterest();
  const { deal, loading, error, refetch } = useCheckoutContext();
  const [dealExpressionsOfInterest, setDealExpressionsOfInterest] = useState([]);
  const { postCode } = deal?.dealer || {};
  const {
    filters: { token, expressionsOfInterest },
  } = collectedFilters();

  const { callDxpDigitalAssignmentEntryEvent } = useNewDxpDigitalAssignmentEntryEvent();
  const {
    platformConfig: { ga4DxpDataLayer },
  } = usePlatformConfig();
  const { jlrDataLayer } = ga4DxpDataLayer ?? {};

  useEffect(() => {
    setDealExpressionsOfInterest(deal?.expressionsOfInterest ? deal.expressionsOfInterest.map(item => item.code) : []);
  }, [deal]);

  const goToNextStep = useCallback(() => handleNext(), [handleNext]);

  const redirectUnavailableDeal = useCallback(() => history.replace(Routes.DEAL_UNAVAILABLE, {}), []);

  const clickContinueCTA = useCallback(() => {
    const codes = expressionsOfInterest?.split(',') ?? [];
    saveExpressionsOfInterest(token, codes)
      .then(() => {
        setDealExpressionsOfInterest(codes);
        refetch();

        if (deal && steps && activeStep) {
          callDxpDigitalAssignmentEntryEvent(
            {
              event_action: removeHostNameFromUrl(window.location.href),
              event_label: `${EventDataTypes.BUTTON} :: ${EventDataTypes.NEXT_BUTTON}`,
              event_category: EventDataTypes.CHECKOUT_CLICK,
              event_pagecategory: EventDataTypes.CHECKOUT,
              click_url: removeHostNameFromUrl(window.location.href),
              click_text: EventDataTypes.NEXT_BUTTON,
              click_name: EventDataTypes.BUTTON,
              ...getEventDataCommonFields(DxpDataLayerEventNames.ADDITIONAL_PRODUCTS_CTA_CLICK, true),
              purchaseOption: {
                vehicle_cash_price: deal.car?.prices?.carPrice?.originalPrice?.[0]?.money?.amount?.toString() ?? '',
                terms: deal.finance?.formInput?.term?.toString() ?? '',
                monthly_mileage: deal.finance?.formInput?.mileage?.toString() ?? '',
                reservation_fee: deal.attributes?.paymentFee?.reserveFee?.[0]?.amount?.toString() ?? '',
                ...getPurchaseOptionCommonFields(deal),
              },
              vproduct: {
                est_delivery_time: deal.car?.deliveryTimeFrame?.toString() ?? '',
                total_weight: '',
                max_speed: '',
                ...vproductCommonFields(deal),
              },
              checkoutStep: {
                ...getCheckoutStepsCommonFields(steps, activeStep),
              },
            },
            jlrDataLayer,
          );
        }

        goToNextStep && goToNextStep();
      })
      .catch(() => {
        history.push({ pathname: Routes.DEAL_UNAVAILABLE });
      });
  }, [
    history,
    token,
    postCode,
    expressionsOfInterest,
    dealExpressionsOfInterest,
    callDxpDigitalAssignmentEntryEvent,
    deal,
    steps,
    activeStep,
    jlrDataLayer,
  ]);

  useEffect(() => {
    if (error) {
      redirectUnavailableDeal();
    }
  }, [error]);

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <Box className={styles.container} data-test={'checkout4:extras:root'}>
        <ExpressionsOfInterest dealExpressionsOfInterest={dealExpressionsOfInterest} />
      </Box>
      <Box className={styles.actionButtonContainer}>
        <ContinueButton
          testId="checkout4:continue_button:extras"
          handleClick={clickContinueCTA}
          activateNextStep={false}
        />
      </Box>
    </>
  );
};

export default Extras;
